import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/frameworks/page.tsx");
